import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import FlipMove from 'react-flip-move';
import CircularProgress from 'material-ui/CircularProgress';
import Comment from '../CommentCell/CommentCell.container';
import styles from './style';
import { ENTER } from '../../../../../../../utils/keyCodes';

const COMMENTS_PER_LOAD = 5;
const INITIAL_COMMENTS_LOAD = 2;
@Radium
class CommentListCollapsable extends React.Component {
  constructor(props) {
    super(props);
    // const collapsed = !props.showInitialComments true;

    this.state = {
      numVisibleComments: props.showInitialComments ? INITIAL_COMMENTS_LOAD : 0,
      collapsed: !props.showInitialComments,
      uncollapsedHeight: 60,
      showSpinner: false,
      shouldRenderList: false,
      indexOfCommentReply: null,
    };

    this.handleCellHeightChange = this.handleCellHeightChange.bind(this);
    this.handleCollapse = this.handleCollapse.bind(this);
    this.handleCollapseFromKeyboard = this.handleCollapseFromKeyboard.bind(
      this
    );
    this.setVisibleComments = this.setVisibleComments.bind(this);
    this.handleReply = this.handleReply.bind(this);
    this.getVisibleComments = this.getVisibleComments.bind(this);
    // this.expand = this.expand.bind(this);
    this._initialFetch = false;
    this.commentsIdBlock = `comments-${Math.round(Math.random() * 1000)}`;
  }

  componentDidMount() {
    this.handleHeightChange();

    if (this.props.showComments) {
      this.handleCollapse();
    }
  }

  componentDidUpdate(prevProps) {
    setTimeout(() => {
      this.handleHeightChange();
    }, 0); // HACK next tick

    const { numVisibleComments, shouldRenderList } = this.state;
    const prevCommentsCount = prevProps.comments.length;
    const commentsCount = this.props.comments.length;
    const commentDiff = commentsCount - prevCommentsCount;

    const newCommentCreated =
      prevProps.showComments !== this.props.showComments;

    if (newCommentCreated && numVisibleComments === 0) {
      this.setState({
        numVisibleComments: numVisibleComments + 1,
        shouldRenderList: true,
        collapsed: false,
      });
    }

    if (numVisibleComments > 0 && commentDiff > 0) {
      this.setState({
        numVisibleComments: numVisibleComments + commentDiff,
        shouldRenderList: true,
        collapsed: false,
      });
    } else if (commentDiff === 0 && shouldRenderList) {
      this.setState({
        shouldRenderList: false,
      });
    }
  }

  getTotalHeight() {
    if (!this.props.commentsCount) {
      return 0;
    }
    return this.state.collapsed ? 45 : this.state.uncollapsedHeight;
  }

  getVisibleComments() {
    const { numVisibleComments } = this.state;
    const { comments } = this.props;
    return numVisibleComments > 0 && numVisibleComments < comments.length
      ? comments.slice(Math.max(0, comments.length - numVisibleComments))
      : comments;
  }

  setVisibleComments() {
    this.setState({ showSpinner: true }, () => {
      this.setState({
        showSpinner: false,
        shouldRenderList: true,
        numVisibleComments: this.props.comments.length,
      });
    });
  }

  handleHeightChange() {
    if (this.refs.wrapper) {
      const height = this.refs.wrapper.offsetHeight;

      if (this.state.uncollapsedHeight !== height && height > 0) {
        this.setState({ ...this.state, uncollapsedHeight: height });
      }
    }
  }

  handleCellHeightChange() {
    setTimeout(() => {
      this.handleHeightChange();
    }, 0);
  }

  handleCollapse() {
    if (this.state.collapsed && !this._initialFetch) {
      this._initialFetch = true;
      this.setState({
        numVisibleComments: COMMENTS_PER_LOAD,
        collapsed: !this.state.collapsed,
      });
    } else {
      this.setState({ collapsed: !this.state.collapsed, visibleComments: 0 });
    }
  }

  handleCollapseFromKeyboard(e) {
    if (e.keyCode === ENTER) this.handleCollapse();
  }

  handleReply(commentIndex) {
    if (this.state.indexOfCommentReply === commentIndex) {
      this.setState({ indexOfCommentReply: null });
      return;
    }
    this.setState({ indexOfCommentReply: commentIndex });
  }

  renderSpinner() {
    if (this.props.isReply) {
      return null;
    }
    if (this.state.showSpinner) {
      return (
        <CircularProgress thickness={2.5} size={25} style={styles.spinner} />
      );
    }
    return null;
  }

  renderLoadMore() {
    if (
      !this.state.showSpinner &&
      this.state.numVisibleComments < this.props.comments.length &&
      !this.state.collapsed
    ) {
      const nbCommentsToLoad =
        this.props.comments.length - this.state.numVisibleComments;
      return (
        <div
          onClick={() => this.setVisibleComments()}
          style={styles.loadMore(this.props.isReply)}
        >
          <span style={styles.loadMoreText}>
            {this.props.isReply
              ? `See ${nbCommentsToLoad} previous repl${
                  nbCommentsToLoad > 1 ? 'ies' : 'y'
                }`
              : 'See previous comments'}
          </span>
        </div>
      );
    }
    if (!this.state.showSpinner) {
      return <div style={{ height: 22 }} />;
    }
    return null;
  }

  renderToggleContent() {
    const carretStyle = {
      ...styles.seeCommentsCarret,
      ...(this.state.collapsed
        ? styles.seeCommentsCarretDown
        : styles.seeCommentsCarretUp),
    };

    return (
      <span style={styles.seeCommentsContainer}>
        {this.state.collapsed && (
          <span style={styles.seeCommentsText}>
            {`Show ${this.props.commentsCount} comment${
              this.props.commentsCount > 1 ? 's' : ''
            }`}
            <span style={styles.seeCommentsCarretWrapper}>
              <div style={carretStyle} />
            </span>
          </span>
        )}
        {!this.state.collapsed && !this.props.isReply && (
          <span style={styles.seeCommentsTextHide}>
            Hide comments
            <span style={styles.seeCommentsCarretWrapper}>
              <div style={carretStyle} />
            </span>
          </span>
        )}
      </span>
    );
  }

  renderToggleContainer() {
    if (this.props.isReply) {
      return null;
    }
    return (
      <div
        role="button"
        tabIndex={0}
        aria-expanded={!this.state.collapsed}
        aria-controls={this.commentsIdBlock}
        onClick={this.handleCollapse}
        onKeyDown={this.handleCollapseFromKeyboard}
        style={styles.seeComments(this.state.collapsed)}
      >
        {this.renderToggleContent()}
      </div>
    );
  }

  render() {
    const displayWrapper = this.props.commentsCount ? 'block' : 'none';
    const wrapperStyle = {
      ...styles.wrapper,
      display: displayWrapper,
    };
    const visibleComments = this.getVisibleComments();
    const shouldRenderBorder = (index) =>
      !this.props.isReply && index !== visibleComments.length - 1;
    return (
      <div
        style={{
          ...styles.container(this.props.isReply),
          ...(this.state.collapsed ? { height: this.getTotalHeight() } : {}),
        }}
      >
        <div ref="wrapper" style={wrapperStyle}>
          {this.renderToggleContainer()}
          {this.renderLoadMore()}
          {this.renderSpinner()}
          {!this.state.collapsed && (
            <div
              id={this.commentsIdBlock}
              style={styles.commentWrapper(this.props.isReply)}
            >
              <FlipMove
                enterAnimation="fade"
                key={this.props.postId}
                disableAllAnimations={
                  !this.state.shouldRenderList || this.props.isReply
                }
              >
                {visibleComments.map((commentId, idx) => (
                  <div key={commentId}>
                    <Comment
                      sequenceId={`post-${this.props.postId}-comment-${commentId}`}
                      postId={this.props.postId}
                      key={commentId}
                      id={commentId}
                      rootCommentId={this.props.rootCommentId || commentId}
                      onHeightChange={this.handleCellHeightChange}
                      toggleReaction={this.props.toggleReaction}
                      onReply={this.props.onReply}
                      renderBorder={shouldRenderBorder(idx)}
                      ReplyContainer={CommentListCollapsable}
                    />
                  </div>
                ))}
              </FlipMove>
            </div>
          )}
        </div>
      </div>
    );
  }
}

CommentListCollapsable.propTypes = {
  comments: PropTypes.array.isRequired,
  commentsCount: PropTypes.number,
  postId: PropTypes.string,
  showComments: PropTypes.bool,
};

export default CommentListCollapsable;
